<template>
  <div class="animated fadeIn">
    <basic-heading title="New Sample Type">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add sample type'">
      <template #gated-content>
        <sample-type-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import SampleTypeForm from "@/components/lab/sampletype/SampleTypeForm";
import { notificationOptions } from "@/shared/toast-notification-options";
import { sampleTypeNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const SampleTypeRepository = LabRepositoryFactory.get("sampleType");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "SampleTypeAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    SampleTypeForm,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/sampletypes",
            title: "Sample type list",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      try {
        const { data } = await SampleTypeRepository.create(form_data);

        this.addSuccess();
        this.$router.push(`/sampletypes/${data.id}`);
      } catch ({ response }) {
        const { status, data } = response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
  notifications: sampleTypeNotifications,
};
</script>
